import { MessageCircle } from "lucide-react";
import { motion } from "framer-motion";
import { whatsappUrl } from "@/data/company";

export const WhatsAppButton = () => (
  <motion.a
    href={whatsappUrl()}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-floating-button"
    aria-label="Scrivici su WhatsApp"
    className="group fixed bottom-5 right-5 z-[60] flex items-center gap-3 rounded-full bg-[#25D366] pl-4 pr-5 py-3 text-white shadow-[0_18px_40px_-12px_rgba(37,211,102,0.7)] sm:bottom-8 sm:right-8"
    initial={{ opacity: 0, scale: 0.6, y: 30 }}
    animate={{ opacity: 1, scale: 1, y: 0 }}
    transition={{ delay: 1.4, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
    whileHover={{ scale: 1.05, y: -2 }}
    whileTap={{ scale: 0.96 }}
  >
    <span className="relative flex h-6 w-6 items-center justify-center">
      <MessageCircle className="h-6 w-6" strokeWidth={2.2} />
      <span className="absolute -right-1 -top-1 h-2.5 w-2.5 rounded-full bg-white animate-pulseDot" />
    </span>
    <span className="font-display text-sm font-bold uppercase tracking-wider">WhatsApp</span>
  </motion.a>
);
